import React from 'react';
import { Redirect, withRouter } from 'react-router';
import PrcRequisitionSearch from '../requisition-search/PrcRequisitionSearch';

/**
 * The initial landing page of GEAR.
 * 
 * If a signed in client reaches this page they will be immediately redirected to the first step of the ordering  
 * process. Any other user (anonymous or signed in patient) will see the patient activate form. A practitioner log-in 
 * button will be displayed off to the side in case a practitioner gets here before signing in.
 * 
 * @param userInfo - The details of the current user
 * @param location - The React Router location object (used to get the URL query string parameters)
 * @param setLoading - A function to hide or show the global loading spinner
 */
function LandingPage({ userInfo, location, setLoading }) {
	if (userInfo === null) {
		return null;
	}

	const isPRC = userInfo.type === 'prc';

	// Redirect a logged in client to the first order step and include any url parameters
	if (!isPRC) {
		return <Redirect to={{ pathname: '/order/new/pract', search: `${location?.search ?? ''}` }} />;
	}

	return (
		<div className="banner section">
			<div className="container">
				<div className="row">
					<div className="col-xs-12">
						<h4
							className="bg-primary"
							style={{
								borderRadius: '15px',
								padding: '6px 25px',
								display: 'inline-block'
							}}
						>
							PATIENTS
						</h4>
					</div>
				</div>

				<div className="row">
					<div className="col-md-8 col-sm-7">
						<h1 className="text-primary">Activate Your Test</h1>
						<PrcRequisitionSearch userInfo={userInfo} setLoading={setLoading} />
					</div>
					<div className="col-md-4 col-sm-5">
						<div
							style={{
								backgroundColor: 'white',
								borderRadius: '15px',
								padding: '20px 30px'
							}}
						>
							<h4 className="text-primary">Healthcare Providers</h4>
							<p>
								Log in to <strong>myGDX</strong> to make test selections, place orders, and Activate
								collection packs for your patients.
							</p>
							<a
								className="btn btn-primary btn-block radius text-primary"
								style={{
									backgroundColor: 'white',
									color: '#337ab7',
									fontWeight: 'bold'
								}}
								// Link to /mygdx/kitordering in case the KitOrdering filter needs to redirect a UK client
								href={`/mygdx/login?url=${window.location.origin}/mygdx/kitordering`}
							>
								Provider Log In
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default withRouter(LandingPage);
